import { Component } from "react";

/** Bitta karta yoki panel xato bersa butun sahifa bo'sh qolmasin — faqat o'sha joyda xabar. */
export class Boundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    console.error(error);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div role="alert" className="m-2 rounded-xl border border-rose-800/50 bg-rose-950/40 p-3 text-xs text-rose-200">
        Bu qismni ko'rsatib bo'lmadi. Sahifani yangilang.
      </div>
    );
  }
}
